import { render, staticRenderFns } from "./InputFilesForm.vue?vue&type=template&id=e66c071a"
import script from "./InputFilesForm.vue?vue&type=script&lang=ts"
export * from "./InputFilesForm.vue?vue&type=script&lang=ts"
import style0 from "./InputFilesForm.vue?vue&type=style&index=0&id=e66c071a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports